
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'

export default {
    name: 'CoursesSettingsGeneral',
    mixins: [ProjectMixin],
    components: {
        AppToolbar,
    },
    data() {
        return {}
    },
}
